import { UserLayout } from '../../../components/User';

export function Users() {
  return <UserLayout />;
}
